// extracted by mini-css-extract-plugin
export default {"close":"CloseButton__close--hrhrd"};